export function openQuestion() {
    document.addEventListener("DOMContentLoaded", function() {

    const questions = document.querySelectorAll('[data-question-open]');
    const gradio = document.querySelectorAll('.gfield_radio');
    const gcheckbox = document.querySelectorAll('.gfield_checkbox');
    const error = document.querySelector('.gform_validation_error');
    const lang = document.documentElement.lang;

    function getChoices(int) {
        if (gradio.length > 0) {
            return gradio[int];
        } else if (gcheckbox.length > 0) {
            return gcheckbox[int];
        }
    }

    function handleErrors() {
        questions.forEach(question => {
            if(question.value == '') {
                question.classList.add('error');
            } else {
                question.classList.remove('error');
            }
        })
    }

    if (questions) {
            questions.forEach(question => {
                question.addEventListener('keyup', function(event) {
                    var answer = document.querySelector('[data-answer-in-text="' + question.dataset.questionOpen + '"]');
                    if (question.value.length > 0) {
                        answer.innerHTML = question.value;
                    } else {
                        answer.innerHTML = "---(" + question.dataset.questionOpen + ")";
                    }
                    var field = getChoices(question.dataset.questionOpen - 1);
                    var labels = field.querySelectorAll('.gform-field-label');
                    var correct = false;


                    labels.forEach(function check(label, index) {
                        var rightanswer = label.innerHTML.toLowerCase().trim();
                        if (rightanswer !== 'fout') {
                            if (lang === 'en-US') {
                                if (label.querySelector('.hide-on-dutch')) {
                                    rightanswer = label.querySelector('.hide-on-dutch').innerHTML.toLowerCase().trim();
                                }
                            } else {
                                if (label.querySelector('.hide-on-english')) {
                                    rightanswer = label.querySelector('.hide-on-english').innerHTML.toLowerCase().trim();
                                }
                            }
                        }
                        if (rightanswer == question.value.toLowerCase().trim()) {
                            if (index != labels.length -1 ) {
                                document.getElementById(labels[index].htmlFor).checked = true;
                                correct = true;
                            } 
                        } else {
                            if (index != labels.length -1 ) {
                                document.getElementById(labels[index].htmlFor).checked = false;
                            }
                        }
                    });
                    if (!correct) {
                        document.getElementById(labels[labels.length - 1].htmlFor).checked = true;
                    } else {
                        document.getElementById(labels[labels.length - 1].htmlFor).checked = false;
                    }
                    correct = false;
                })
            })
        }

        // Use MutationObserver to detect changes in .question-form
        const questionForm = document.querySelector('.gform-theme');
        if (questionForm) {
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {  // Check if it's an element node
                            if (node.classList.contains('gform_validation_errors')) {
                                handleErrors();
                            }
                        
                        }
                    });
                });
            });
    
            // Configure the observer to watch for child nodes being added
            observer.observe(questionForm, { childList: true, subtree: true });
        } else {
        }


});  
}